export default __webpack_public_path__ + "static/favicon-32-3b755831a360d5f0d0f16b4ba2fd7916.png";